import React from 'react'

import * as c from '../../common'
import * as r from '../../react-utils'

import YesOrNo from './YesOrNo'

interface ConnectedYesOrNoProps {
  customerID: string
  disabled?: boolean
  field: c.CustomerField
  on: c.Surface
}

export default React.memo<ConnectedYesOrNoProps>(function ConnectedYesOrNo({
  customerID,
  disabled,
  field,
  on,
}) {
  const [customer] = r.useCustomer(customerID)
  const [yesOrNo, setYesOrNo] = r.useCustomerField(customerID, field)

  const handleUpdateCheckbox = React.useCallback(
    (newYesOrNo: 'no' | 'yes') => void setYesOrNo(newYesOrNo),
    [setYesOrNo],
  )

  return (
    <YesOrNo
      canBeEmpty={c.CustomerSchema[field] === c.YesNoEmpty}
      disabled={disabled}
      grow={!!c.adderToInputs[field] || c.fieldToGrow[field]}
      hide={c.shouldHideInput(field, customer)}
      label={c.getFieldLabel(field)}
      on={on}
      onPress={handleUpdateCheckbox}
      value={yesOrNo as typeof c.YesNoEmpty}
    />
  )
})
